// extracted by mini-css-extract-plugin
module.exports = {"container":"settings-block_container__76mVc","title":"settings-block_title__1jsAS"};